import { configureStore } from "@reduxjs/toolkit";
import toggleReducer from "../features/toggler/toggleSlice";
export const store = configureStore({
  reducer: {
    toggle: toggleReducer,
  },
});
